import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = () => ({
  business_types: [],
});

export default {
  state,
  getters,
  actions,
  mutations,
};
